import { getQuestionIndicatorStyle, moduleColors, moduleBoxHWBr, moduleDesc } from "./utils";
import log from "loglevel";
import { useEffect } from "react";

const QuestionsNavigation = ({ questionRefs, otherActivityData }) => {

    // Use same ordering logic as QuestionsList
    const modules = otherActivityData?.questionmodule_set || [];
    const allQuestions = otherActivityData?.question_set || [];
    const standaloneQuestions = allQuestions.filter(q => !q.module);

    // Group questions by module
    const modulesWithQuestions = modules.map(module => ({
        ...module,
        question_set: allQuestions.filter(q => q.module === module.id)
    }));

    // Create unified list combining modules and standalone questions (same as QuestionsList)
    const unifiedList = [
        ...modulesWithQuestions.map(module => ({
            ...module,
            itemType: 'module',
            order: module.order ?? 0
        })),
        ...standaloneQuestions.map(question => ({
            ...question,
            itemType: 'question',
            order: question.order ?? 0
        }))
    ].sort((a, b) => {
        const orderDiff = (a.order ?? 0) - (b.order ?? 0);
        if (orderDiff !== 0) return orderDiff;
        if (a.itemType !== b.itemType) {
            return a.itemType === 'question' ? -1 : 1;
        }
        return a.id - b.id;
    });

    // Flatten to get all questions in display order
    const seenQuestions = new Set();
    const orderedQuestions = [];

    unifiedList.forEach(item => {
        if (item.itemType === 'module') {
            // Add module questions
            item.question_set.forEach(q => {
                if (!seenQuestions.has(q.id)) {
                    seenQuestions.add(q.id);
                    orderedQuestions.push(q);
                }
            });
        } else if (item.itemType === 'question') {
            // Add standalone question
            if (!seenQuestions.has(item.id)) {
                seenQuestions.add(item.id);
                orderedQuestions.push(item);
            }
        }
    });

    useEffect(() => {
        log.log("[QuestionsNavigation] Component rendered/updated");
        log.log("[QuestionsNavigation] Total questions in display order:", orderedQuestions.length);
        orderedQuestions.forEach((q, idx) => {
            log.log(`[QuestionsNavigation] Question ${idx + 1} (ID: ${q.id}):`, {
                question_type: q.question_type,
                has_response: !!q.questionresponse_set,
                response_text: q.questionresponse_set?.response_text
            });
        });
    }, [otherActivityData]);

    const scrollToQuestion = (index) => {
        if (questionRefs.current[index]) {
            questionRefs.current[index].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        }
    };

    return (
        <div className="section-full-border" style={{ flex: 1, height: "max-content", marginBottom: "30px", marginRight: "10px" }}>
            <h6 className="p-2 py-3" style={{ borderBottom: "1px solid #DFDFDF" }}>
                Questions
            </h6>
            <div className="p-2" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 15 }}>
                <div className="d-flex" style={{ gap: 10 }}>
                    <div style={{ backgroundColor: moduleColors.rightAnswer, ...moduleBoxHWBr }}></div>
                    <p style={moduleDesc} className="mb-0">Attempted</p>
                </div>
                <div className="d-flex" style={{ gap: 10 }}>
                    <div style={{ backgroundColor: "#fff", border: "1px solid #757589", ...moduleBoxHWBr }}></div>
                    <p style={moduleDesc} className="mb-0">Not Attempted</p>
                </div>
            </div>
            <div className="p-2" style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 16, maxWidth: 238 }}>
                {orderedQuestions.map((activity, index) => {
                    const style = getQuestionIndicatorStyle(activity, index, index);
                    log.log(`[QuestionsNavigation] Question ${index + 1} (ID: ${activity.id}) style:`, style);
                    return (
                        <div
                            key={activity.id}
                            onClick={() => scrollToQuestion(index)}
                            style={{ ...style, border: "2px solid black" }}
                        >
                            {index + 1}
                        </div>
                    );
                })}
            </div>

        </div>
    );

}

export default QuestionsNavigation;